/*
 * 使用 jt-table 时与项目耦合的代码
 * 在该文件中定义表格分页请求的前处理和后处理函数, 和项目的接口格式进行匹配
 *
 * */

import { IS_DEV } from '@/const'
import { ResponseSchema } from '@/types/axios/public-json-structure'
import type { JtTableProps } from './types'

/**
 * 将项目中 jt-table 分页查询时的请求参数进行自定义转换
 * 根据内部暴露的 pageSize 和 pageNum 2个参数, 转换为项目中分页接口约定的查询参数
 * @param paginationParams jt-table 内部分页查询参数
 * @return 项目列表接口查询中和分页相关的参数
 * */
export const requestInterceptor: JtTableProps.RequestInterceptor =
  function requestInterceptor(paginationParams) {
    return {
      ...paginationParams
    }
  }

/**
 * 将项目中列表页接口固定格式的数据转为 jt-table 约定好的数据源格式
 * @param rawRes webPagination 函数返回的数据
 * @return  jt-table 表格和分页的数据
 * */
export const responseInterceptor: JtTableProps.ResponseInterceptor<ResponseSchema> =
  function (rawRes) {
    const total = rawRes.page?.total ?? 0
    const pageNum = rawRes.page?.pageNum ?? 0
    const pageSize = rawRes.page?.pageSize ?? 0
    const pages = rawRes.page?.pages ?? 0

    const list: any[] = rawRes.data ?? []

    if (IS_DEV) {
      if (rawRes.page === undefined) {
        console.error(
          '[jt-table] responseInterceptor 函数异常. 列表页接口返回的数据中缺少 "page" ! 接口返回数据:',
          rawRes
        )
      } else if (rawRes.page?.total === undefined) {
        console.error(
          '[jt-table] 列表页接口返回的数据中 "page" 字段缺少 "total" 字段! 接口返回数据:',
          rawRes
        )
      }

      if (rawRes.data === undefined) {
        console.error(
          '[jt-table] 列表页接口返回的数据缺少 "list" 字段. 接口返回数据:',
          rawRes
        )
      } else if (!Array.isArray(rawRes.data)) {
        console.error(
          '[jt-table] 列表页接口返回的数据中 "list" 字段对应的数据类型不符合要求, 需要类型: Array. 实际返回数据:',
          rawRes.data
        )
      }
    }

    return {
      data: list,
      page: {
        total,
        pageNum,
        pages,
        pageSize,
      }
    }
  }
